import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDefined',
  standalone: true,
})
export class IsDefinedPipe implements PipeTransform {
  public transform(value: unknown): boolean {
    return value != null;
  }
}
